// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1jVVs","name":"Header_name__1mjwJ","birthday":"Header_birthday__1SpyI","skeleton":"Header_skeleton__1PYf0"};